import { Locale, LOCALE_US, LOCALE_DEBUG, LOCALE_PSEUDO } from '../locales/constants';

export function handleLocalizedImageUrl(url: string, locale: Locale): string {
    let parsedUrl;
    try {
        parsedUrl = new URL(url);
    } catch (err) {
        throw new Error(
            `handleLocalizedImageUrl couldn't parse "${url}". We only support absolute URLs`
        );
    }

    if (locale === LOCALE_US || locale === LOCALE_PSEUDO || locale === LOCALE_DEBUG) {
        return parsedUrl.href;
    }

    const segments = parsedUrl.pathname.split('/').filter(Boolean);
    const filename = segments.pop();

    parsedUrl.pathname = [...segments, locale, filename].join('/');

    return parsedUrl.href;
}
